import React, { useState, useEffect } from "react";
import FormProgress from "./FormProgress";
import Tabs from "./Tabs";
import Box from "@mui/material/Box";
import MainLayout from "../../nav/MainLayout";
import { styled } from "@mui/material/styles";
import "./unitAdmin.scss";
import submitGif from "../../../assets/img/submit.gif";
import { useRecoilValue } from "recoil";
import {
  unitDetailsSubmitAtom,
  formProgress,
  formId,
} from "../../../store/atoms";
import Footer from "../../reusables/Footer";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));
const UnitAdmin = () => {
  // const [submitDone, setSubmitDone] = useState(false);
  const formIdValue = useRecoilValue(formId);
  // console.log("formId value", formIdValue);
  const submitDone = useRecoilValue(unitDetailsSubmitAtom);
  const progressValue = useRecoilValue(formProgress);
  // const [modalOpen, setModalOpen] = useRecoilState(editLoading);
  const [unitIndexValue, setUnitIndexValue] = useState("");

  const queryParams = new URLSearchParams(window.location.search);
  const auditNumber = queryParams.get("auditNumber");

  const id = auditNumber ? auditNumber : formIdValue;
  console.log("unitIndexValue", unitIndexValue);




  return (
    <>
      <div id="audit-page">
        <Box
          className="mainLayout"
          sx={{ display: "flex", overflow: "hidden" }}
        >
          <MainLayout />
          <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
            <DrawerHeader />
            <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />
            <div id="mainHome">
              <div className="audit-id" style={{display:"flex", flexDirection:"column",alignItems:"flex-end"}}>
                <span id="auditNumberID1">Mars QMS Audit #: {id}</span>
                 {unitIndexValue && <span style={{fontSize:"16px",color:"#8d8d8d",fontWeight:"500"}}>Unit Index is #: {unitIndexValue || "N/A"}</span>}

              </div>
              {!submitDone ? (
                <>
                  <FormProgress />
                  <div className="audit-container">
                    <Tabs setUnitIndexValue={setUnitIndexValue} />
                  </div>
                </>
              ) : (
                <div className="submitGif-box">
                  <img src={submitGif} alt="submitgif" />
                </div>
              )}

              <Footer />
            </div>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default UnitAdmin;
